<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.username" label="Usuário" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                  <v-text-field clearable v-model="pesquisa.email" label="E-mail" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined color="primary" type="submit">
                    <v-icon>mdi-magnify</v-icon>
                    esquisar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="editar(item)" class="mr-1" :disabled="!!item.roles.filter(el => el === 'ROLE_USER')[0]">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
            <span>Edição</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card flat class="mt-2">

        <v-toolbar flat color="accent">
          <v-toolbar-title>Cadastrar/Alterar Usu&aacute;io</v-toolbar-title>
          <v-chip
            v-if="usuario.id != undefined"
            close
            @click:close="resetarFormulario()">
            {{ usuario.username }}
          </v-chip>
        </v-toolbar>

        <v-card outlined>
          <v-card-text>
            <v-form  ref="form" @submit="salvar()" v-model="valid" :lazy-validation="lazy" id="edit-form" v-on:submit.prevent>
              <v-container fluid>
                <v-row>
                  
                  <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field label="Usuário" v-model="usuario.username" :rules="validacao.username" :disabled="disabled"></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field label="Nome" v-model="usuario.first_name" :rules="validacao.first_name"></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field label="E-mail" v-model="usuario.email" :rules="validacao.email" type="email"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-text-field label="Senha" clearable type="password" :disabled="!senhaHabilitada" prepend-inner-icon="mdi-lock" v-model="usuario.pw_emp_log_1_t" :rules="[(v) => { if(!this.usuario.id){  if(!v){ return 'Requerido' }else{ return true } return } else {return true} }, validaSenha()]" ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-text-field label="Confirma Senha" type="password" :disabled="!senhaHabilitada" prepend-inner-icon="mdi-lock" v-model="usuario.pw_emp_log_2_t" :rules="[validaSenha()]" ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn depressed outlined color="primary" type="submit">{{ usuario.id != undefined ? 'CONFIRMAR ALTERAÇÕES' : 'CONFIRMAR INSERÇÃO'}}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-card>

  </div>
</template>
<script>
  import lodash from 'lodash'
  export default {

    components: {

    },

    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Usuário', value: 'username', sortable:false, width: 80 },
          { text: 'Nome', value: 'first_name', sortable:false, width: 80 },
          { text: 'E-mail', value: 'email', sortable:false, width: 80 },
          { text: 'Ativo', value: 'enabled', sortable:false, width: 80 },
          { text: '', value: 'action', sortable:false, width: 120, align: 'right' },
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          username: undefined,
          email: undefined,
        },

        /** propriedades de persistencia*/
        lazy: false,
        valid: true,
        disabled: false,

        filiais:[],
        senhaHabilitada: true,
        
        usuario: {
            id: undefined,
            username: undefined,
            password: undefined,
            first_name: undefined,
            last_name: undefined,
            email: undefined,
            phone_number: undefined,
            enabled: true,
            last_password_reset_date: undefined, // timestamp
            cc_org: undefined,
            cc_fil: undefined,
        },

        validacao: {
          username:[
            (v) => !!v || 'Requerido',
          ],
          first_name:[
            (v) => !!v || 'Requerido',
          ],
        },

      }
    },

    computed: {
      validaSenha() {
        return () => {
            //if(this.senhaHabilitada){
                if(((this.usuario.pw_emp_log_1_t !== undefined && this.usuario.pw_emp_log_1_t !== '') || 
                    (this.usuario.pw_emp_log_2_t !== undefined && this.usuario.pw_emp_log_2_t !== '')) &&
                    this.usuario.pw_emp_log_1_t !== this.usuario.pw_emp_log_2_t){
                    return 'Não confere'
                } else {
                    return true
                }
            //} else {
            //    return true
           // }
        }
      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },
    },

    mounted () {

      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()

    },

    created(){
      this.$vuetify.goTo(0)
    },

    methods: {

      editar(obj){

        this.disabled = true
        this.usuario = lodash.clone(obj)
        this.$vuetify.goTo('#edit-form', {duration: 500,
          offset: 0,
          easing: 'linear',
        })
      },

      salvar() {

        let a = 'dd'
        let b = 321
        console.log((!!a || b===1) || 'requerido')

        if (this.$refs.form.validate()) {
          
          this.usuario.last_password_reset_date = Date.now()
          this.usuario.password = undefined
          if(this.usuario.pw_emp_log_1_t !== undefined && this.usuario.pw_emp_log_1 !== ''){
            this.usuario.password = this.usuario.pw_emp_log_1_t
          }

          let promise = undefined;
          if(this.usuario.id === undefined) {
              promise = this.$store.dispatch('salvarUsuario', this.usuario)
          }else {
              promise = this.$store.dispatch('alterarUsuario', this.usuario)
          }

          promise.then(() => {

            if(this.usuario.id !== undefined) {
              let item = this.itens.filter((el) => {return el.id === this.usuario.id})
              if(item.length > 0){
                Object.assign(this.itens[this.itens.indexOf(item[0])], this.usuario)
              }
            }

            this.resetarFormulario()
          }).catch(err => {
            console.log(err)
          })

        }
      },

      resetarFormulario() {
        this.disabled = false
        this.usuario.id = undefined
        this.$refs.form.reset()
      },

      pesquisar() {
        this.resetarFormulario()
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage,
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaUsuario', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>